<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">search</i>
                        </div>
                        <h4 class="card-title ">Filtros</h4>
                    </div>
                    <b-form @submit.prevent="onSubmit" @reset.prevent="onReset" novalidate="novalidate" autocomplete="off">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger': validation.type != null}">
                                        <label for="type" class="bmd-label-floating">Tipo</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="type_profiles"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.type">
                                        </model-list-select>
                                        <label v-if="validation.type != null" id="type-error" class="error" for="type">{{ validation.type }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger': validation.proposal_status_id != null}">
                                        <label for="type" class="bmd-label-floating">Status</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="proposal_status"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.proposal_status_id">
                                        </model-list-select>
                                        <label v-if="validation.proposal_status_id != null" id="proposal_status_id-error" class="error" for="proposal_status_id">{{ validation.proposal_status_id }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.administrator_id != null}">
                                        <label for="administrator_id" class="bmd-label-floating">Administradora</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="administrators"     
                                            placeholder="Todas"
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.administrator_id">
                                        </model-list-select>
                                        <label v-if="validation.administrator_id != null" id="administrator_id-error" class="error" for="administrator_id">{{ validation.administrator_id }}</label>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger': validation.date_type != null}">
                                        <label for="type" class="bmd-label-floating">Período</label>
                                        <model-list-select 
                                            class="form-control"
                                            :list="date_types"     
                                            option-value="id"
                                            option-text="name"
                                            v-model="form.date_type">
                                        </model-list-select>
                                        <label v-if="validation.date_type != null" id="date_type-error" class="error" for="date_type">{{ validation.date_type }}</label>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group bmd-form-group is-filled" v-bind:class="{'has-danger' : validation.date_at != null}">
                                        <label for="interval" class="bmd-label-floating">Intervalo</label>
                                        <date-picker
                                            range
                                            v-model="form.date_at"
                                            lang="pt-br"
                                            format="DD/MM/YYYY"
                                            placeholder="Escolha uma data"
                                            :not-after="form.end_at"
                                            >
                                        </date-picker>
                                        <label v-if="validation.date_at != null" id="date_at-error" class="error" for="date_at">{{ validation.date_at }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                            <button type="reset" class="btn btn-fill btn-outline-danger">Limpar</button>
                            <button type="submit" class="btn btn-fill btn-rose">Gerar</button>
                        </div>
                    </b-form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        computed: {
            administrators: {
                get() {
                    return this.$store.state.administrators.itens;
                }
            },
            date_types: {
                get() {
                    return [
                        {id: 'month', name: 'Mensal'},
                        {id: 'range', name: 'Faixa'}
                    ];
                }
            },
            proposal_status: {
                get() {
                    return [
                        {
                            id: 1,
                            name: 'Novas'
                        },
                        {
                            id: 3,
                            name: 'Contempladas'
                        },
                        {
                            id: 4,
                            name: 'Faturadas'
                        },
                        {
                            id: 5,
                            name: 'Canceladas'
                        },
                        {
                            id: '',
                            name: 'Todas'
                        }
                    ];
                }
            }
        },
        data() {
            return {
                form: {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    date_type: 'month',
                    end_at: Vue.moment(),
                    type: null,
                    proposal_status_id: ''
                },
                type_profiles: [
                    {id: 'salesmans', name: 'Vendedores'},
                    {id: 'teams', name: 'Equipes'}
                ],
                validation: {
                    administrator_id: null,
                    date_at: null,
                    date_type: null,
                    type: null,
                    proposal_status_id: null
                }
            };
        },
        methods: {
            async getDataAdministrators() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch('administrators/all');

                response.then(function () {
                    self.$root.$emit("onLoading");
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
            onReset() {
                this.form = {
                    administrator_id: null,
                    date_at: [Vue.moment().subtract(30, "days"), Vue.moment()],
                    end_at: Vue.moment(),
                    type: null,
                    date_type: 'month'
                };
            },
            onSubmit() {
                var self = this;
                var valid = true;

                self.validation = {
                    administrator_id: null,
                    date_at: null,
                    date_type: null,
                    type: null,
                    proposal_status_id: null
                };

                if (self.form.type == null) {
                    valid = false;
                    self.validation.type = 'Favor informar o tipo desejado!';
                }

                if (self.form.administrator_id == null) {
                    valid = false;
                    self.validation.administrator_id = 'Favor informar a administradora desejada!';
                }

                if (self.form.date_type == null || self.form.date_type == "") {
                    valid = false;
                    self.validation.date_type = 'Favor informar o tipo do intervalo desejado!';
                }
                
                if (self.form.date_at[0] == null || self.form.date_at[1] == null) {
                    valid = false;
                    self.validation.date_at = 'Favor informar o intervalo desejado!';
                }
                
                if (valid) {
                    var serialize = JSON.stringify(self.form);
                    
                    window.open("print-commission-of-months?form=" + serialize, '_blank');
                }
            }
        },
        mounted() {
            var self = this;

            self.getDataAdministrators();

             setTimeout(() => {
                self.administrators.unshift(
                    {
                        id : '',
                        name : 'Todas'
                    }
                );
            }, 1000);
        }
    }
</script>
